import { useState, useCallback } from "react";

/**
 * Custom hook for managing modal states
 * Consolidates all modal-related state and handlers
 */
export const useModalState = () => {
  // Modal visibility states
  const [showAddItemModal, setShowAddItemModal] = useState(false);
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const [showPersonnelConfirmModal, setShowPersonnelConfirmModal] =
    useState(false);
  const [showReturnModal, setShowReturnModal] = useState(false);

  // Modal handlers
  const openAddItemModal = useCallback(() => setShowAddItemModal(true), []);
  const closeAddItemModal = useCallback(() => setShowAddItemModal(false), []);

  const openSignatureModal = useCallback(() => setShowSignatureModal(true), []);
  const closeSignatureModal = useCallback(
    () => setShowSignatureModal(false),
    []
  );

  const openPersonnelConfirmModal = useCallback(
    () => setShowPersonnelConfirmModal(true),
    []
  );
  const closePersonnelConfirmModal = useCallback(
    () => setShowPersonnelConfirmModal(false),
    []
  );

  const openReturnModal = useCallback(() => setShowReturnModal(true), []);
  const closeReturnModal = useCallback(() => setShowReturnModal(false), []);

  // Close all modals
  const closeAllModals = useCallback(() => {
    setShowAddItemModal(false);
    setShowSignatureModal(false);
    setShowPersonnelConfirmModal(false);
    setShowReturnModal(false);
  }, []);

  return {
    // Modal states
    showAddItemModal,
    showSignatureModal,
    showPersonnelConfirmModal,
    showReturnModal,

    // Modal handlers
    openAddItemModal,
    closeAddItemModal,
    openSignatureModal,
    closeSignatureModal,
    openPersonnelConfirmModal,
    closePersonnelConfirmModal,
    openReturnModal,
    closeReturnModal,
    closeAllModals,
  };
};
